/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface LogCreateRequest {
  locked?: boolean;
  groupId: string;
  name: string;
  note?: string | null;
  context?: object | null;
  defaultWorkflowId?: string | null;
}

export function LogCreateRequestFromJSON(json: any): LogCreateRequest {
  return LogCreateRequestFromJSONTyped(json);
}

export function LogCreateRequestFromJSONTyped(json: any): LogCreateRequest {
  if (json == null) {
    return json;
  }

  return {
    locked: json["locked"],
    groupId: json["group_id"],
    name: json["name"],
    note: json["note"],
    context: json["context"],
    defaultWorkflowId: json["default_workflow_id"],
  };
}

export function LogCreateRequestToJSON(
  value: LogCreateRequest | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    locked: value.locked,
    group_id: value.groupId,
    name: value.name,
    note: value.note,
    context: value.context,
    default_workflow_id: value.defaultWorkflowId,
  };
}
